import { apiWrapper } from "@/services/api";
import store from "@/store";

export const getCardInfo = async () => {
  let response;
  try {
    response = await apiWrapper(
      "GET",
      "card-info",
      {},
      false,
      null,
      "Migrated"
    );
    store.commit("common/setCreditCard", response.data);
    return response.data;
  } catch (err) {
    console.log('ERROR"" getCardInfo():', err);
    throw err;
  }
};
